import { jsx } from 'react/jsx-runtime';
import { Lock } from '@zooplus/icons';
import FormControl from '../FormControl/FormControl.js';
import FormControlWrapper from '../FormControlWrapper/FormControlWrapper.js';
import { useTranslation } from '../../hooks/useTranslations.js';
import styles from './CardNumberFormField.module.scss.js';

/**
 * The input field for credit card number to show in the credit card form.
 */
const CardNumberFormField = ({ id, detectedBrandsController, errorMessage, focused, icon, labelInline = false, hasInfoMessage = true, hasLabel = true, }) => {
    const { t } = useTranslation();
    const infoMessage = {
        infoMessage: t('checkout.payment.secure'),
        infoMessageIcon: jsx(Lock, {}),
    };
    return (jsx(FormControlWrapper, { labelFor: "encryptedCardNumber", labelInline: labelInline, errorMessage: errorMessage, errorZta: "errorInputCreditCardNumber", ...(hasLabel ? { label: t('checkout.payment.creditcard.card_number') } : {}), ...(hasInfoMessage ? infoMessage : {}), children: jsx(FormControl, { appendixItems: detectedBrandsController, innerClassname: styles.noPadding, id: id, "data-cse": id, hasError: errorMessage !== null, focused: focused, "data-zta": "inputCreditCardNumber", icon: icon }) }));
};

export { CardNumberFormField as default };
//# sourceMappingURL=CardNumberFormField.js.map
